import { createTheme, TableColumn, TableStyles } from "react-data-table-component";
import { Mob } from "../../models/mob";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

createTheme('custom', {
  text: {
    primary: '#ddd',
    secondary: '#ddd'
  },
  background: {
    default: 'transparent'
  },
  context: {
    background: '#cb4b16',
    text: '#FFFFFF',
  },
  divider: {
    default: '#444',
  },
  button: {
    default: '#2aa198',
    hover: 'rgba(0,0,0,.08)',
    focus: 'rgba(255,255,255,.12)',
    disabled: 'rgba(255, 255, 255, .34)',
  },
  sortFocus: {
    default: '#2aa198',
  },
  striped: {
    default: 'rgba(0,0,0,.05)'
  }
}, 'dark');

export const styles: TableStyles = {
  headRow: {
    style: {
      fontSize: '12px'
    }
  },
  rows: {
    style: {
      fontSize: '14px',
      paddingTop: '.5rem',
      paddingBottom: '.5rem'
    }
  }
}

export const getColumns: (query: string) => TableColumn<Mob>[] = (query: string) => {
  const queryRegex = new RegExp(query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'ig');
  const Highlight = ({value}: {value: any}) => {
    let text: string = value.toString();
    if (!query || text.toLowerCase().indexOf(query.toLowerCase()) === -1) {
      return <>{text}</>;
    } else {
      text = text.replace(queryRegex, (match: string) => '<span style="color: yellow;">' + match + '</span>');
      return <span dangerouslySetInnerHTML={{__html: text}}/>
    }
  }

  return [
    {
      id: 'name',
      name: 'Name',
      selector: row => row.name,
      cell: row => <Highlight value={row.name}/>,
      sortable: true,
      sortFunction: (a, b) => a.name.replace(/^(?:an?|the) /, '').localeCompare(b.name.replace(/^(?:an?|the) /, '')),
      minWidth: '300px',
      grow: 0,
      wrap: true
    },
    {
      id: 'items',
      name: 'Items',
      selector: row => row.sortedItems.map((x) => x.key + ' ' + x.val + '%').join(' '),
      cell: row => (
        <div className="items-columns">
          {row.sortedItems.map((x, i) => <div key={i}><span className="text-muted">&bull;</span> <Highlight value={x.key}/> <span className="ms-1 text-muted"><Highlight value={' ' + x.val + '%'}/></span></div>)}
        </div>
      ),
      sortable: true,
      grow: 1,
      wrap: true
    },
    {
      id: 'count',
      name: 'Sample',
      selector: row => row.total,
      cell: row => <Highlight value={row.total}/>,
      sortable: true,
      grow: 0,
      wrap: true
    },
    {
      id: 'room',
      name: 'Room',
      selector: row => row.roomId + ' ' + row.zone + ' ' + row.room,
      cell: row => (
        <Link style={{textDecoration: 'none'}} to={'/map?roomId=' + row.roomId}>
          <OverlayTrigger overlay={<Tooltip style={{position: 'fixed'}}><b>{row.zone}:</b><br/>{row.room}</Tooltip>}>
            <div className="text-success" tabIndex={0}><Highlight value={row.roomId}/></div>
          </OverlayTrigger>
        </Link>
      ),
      sortable: true,
      grow: 0,
      wrap: true
    },
    {
      id: 'updated',
      name: 'Updated',
      selector: row => moment(row.updated).format('M/DD/YY'),
      cell: row => <Highlight value={moment(row.updated).format('M/DD/YY')}/>,
      sortable: true,
      sortFunction: (a, b) => moment(a.updated).diff(b.updated),
      minWidth: '100px',
      grow: 0,
      wrap: true
    }
  ];
};
